import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-modal-select-existing-calculation',
  templateUrl: './modal-select-existing-calculation.component.html'
})
export class ModalSelectExistingCalculationComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  existingCalculations: any[] = [];
  selectedCalculation: any = null;
  isLoading: boolean = true;
  templateName: string = '';

  constructor(
    public modalService: ExgModalService,
    private excRestService: ExcRestService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.templateName = this.data?.templateName ||'';
    this.loadExistingCalculations();
  }

  loadExistingCalculations(): void {
    this.isLoading = true;

    setTimeout(() => {
      if (this.data.calculationVersions) {
        this.existingCalculations = this.data.calculationVersions.filter((cv: any) =>
          cv.cv_ctID === this.data.ctID
        );
      } else {
        this.existingCalculations = [];
      }
      this.isLoading = false;
    }, 100);
  }

  selectCalculation(calculation: any): void {
    this.selectedCalculation = calculation;
  }

  openSelectedCalculation(): void {
    if (this.selectedCalculation) {
      this.modalService.action({
        action: 'createWithPreset',
        presetCalculation: this.selectedCalculation
      });
    }
  }

  createNewCalculation(): void {
    this.modalService.action({action: 'createNew'});
  }

  dirty(): boolean {
    return !this.selectedCalculation && this.existingCalculations.length > 0;
  }

  close(): void {
    this.modalService.close();
  }
}
